export enum TableNames {
  COMPANY_PARTS = 'companyParts',
  COSTING_LIST = 'costingList',
  HISTORY_LIST = 'historyList',
  IMPORT_CHOOSE_MANUFACTURER = 'importChooseManufacturer',
  IMPORT_PARTS = 'importParts',
  IMPORT_PREVIEW_ROWS = 'importPreviewRows',
  IMPORT_UNKOWN_MANUFACTURERS = 'importUnkownManufacturers',
  INVENTORY_LIST = 'inventoryList',
  JOB_LIST = 'jobList',
  JOB_MATERIAL_VIEW_BY_PART_LIST = 'jobMaterialViewByPartList',
  MANAGE_USERS = 'usersTableList',
  PRICING_LIST = 'pricingList',
  RANKS = 'usersRanksList',
  SUPPORT_REQUEST_DISCIPLINE_JOB_LIST = 'supportRequestDisciplineJobList',
  SUPPORT_REQUEST_JOB_LIST = 'supportRequestJobList',
  SUPPORT_REQUEST_LIST = 'supportRequestList',
  UOMS_LIST = 'uomsList',
}
